import { IData } from '../fetchTaxes'
import { ITaxesDictionary } from '../index'

export default function(response: IData) {
  return response.items.map(
    (item): ITaxesDictionary => ({
      createdAt: String(item.created_at),
      deleted: Boolean(Number(item.deleted)),
      id: Number(item.id),
      idObject: Number(item.id_object),
      rate: String(item.rate),
      updatedAt: String(item.updated_at),
    }),
  )
}
